export default "__VITE_ASSET__BRjgWPmc__"